var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.view.isPrepared)?_c('router-view'):_vm._e(),(_vm.checkEtcPopup)?_c('etc-popup',{ref:"etcPop",attrs:{"popupSet":_vm.view.popupSet},on:{"version-api-called":_vm.linkBack}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }